/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import ViewOff20 from '@carbon/icons-react/es/view--off/20';
import React, { FC } from 'react';
import { UserType } from 'api/models';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
import { PrivateSectionContext } from 'components/organisms/ck-collab-editor/private-section-context';
import { useTranslation } from 'hooks/use-translation';
import { useUserType } from 'hooks/use-user-type';
import { StyledToolItem } from '../styled-components';
import styles from './private-section.module.css';

export const InsertPrivateSection: FC = () => {
  const label = useTranslation('toolbar.insert_private_section');

  const userType = useUserType();

  return userType === UserType.Native ? (
    <PrivateSectionContext.Consumer>
      {({ isPrivateSectionEnabled, togglePrivateSection }) => (
        <div
          className={`${styles.button} ${
            isPrivateSectionEnabled ? styles.disabled : ''
          }`}
          data-testid="privateSectionWrapper"
          onClick={togglePrivateSection}
        >
          <StyledToolItem>
            <IconWrapper>
              <ViewOff20 data-testid="privateSectionIcon" />
            </IconWrapper>
            {label}
          </StyledToolItem>
        </div>
      )}
    </PrivateSectionContext.Consumer>
  ) : null;
};
